<template>
  <a-range-picker :defaultPickerValue='rangedata' :disabledDate='disabledDate' :valueFormat='format' :format='format'  @change="onChange" />
</template>

<script>
  import { reactive, toRefs, inject, onMounted } from "vue";
  export default {
    name: "rangeDisabledDate",
    props: {
      rangedata: Array, 
      format:String, // 日期格式
      type:String, // 禁用日期类型 first（只能选当前日期以前的）  after（只能选当前日期以后的）
    },
    setup(props,{emit}) {
      const state = reactive({
        rangedata:[],
        format: 'YYYY-MM-DD',
        disabledDate:null
      });
      const momentTime = inject("momentTime");
      // 只能轩前30天的日期，当天也不可选
      const firstDisabledDate = (current) => {
        return current < momentTime().subtract(31, 'day') || current > momentTime().subtract(1, 'days');
      }
      // 只能选后90天，当天可选
      const afterDisabledDate = (current) => {
        return current > momentTime().add(91, 'day') ||  current < momentTime().subtract(1, 'days');
      }
      const onChange = (e) =>{
        emit("update:value",e)
        emit('ontimechange',e)
      }
      onMounted(() => {
        if(props.type == 'first'){
          state.disabledDate = firstDisabledDate
        }else{
          state.disabledDate = afterDisabledDate
        }
      });
      return {
        ...toRefs(state),
        onChange,
        firstDisabledDate,
        afterDisabledDate,
        momentTime
      }
    }
  }
</script>